import Input from "../../../utils/components/Input";
import Button from "../../../utils/components/Button";
import { HiPlus, HiMinus } from "react-icons/hi";

const Increment = ({ value, min, max, disabled, onChange }) => {
  return (
    <div className="row w-100">
      <div className="d-flex align-items-center">
        <Input
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value))}
          type="number"
          disabled={disabled}
          inputProps={{
            min,
            max,
          }}
        />
        {!disabled && (
          <div className="d-flex mt-2">
            <Button
              className="border border-2 ms-2"
              disabled={(min && value <= min) || value === 0}
              onClick={() => {
                if ((min && value <= min)) return false;
                onChange(value - 1);
              }}
            >
              <HiMinus className="fs-4 text-orange"/>
            </Button>
            <Button
              className="border border-2 ms-2"
              disabled={max && value >= max}
              onClick={() => {
                if ((max && value >= max)) return false;
                onChange(value + 1);
              }}
            >
              <HiPlus className="fs-4 text-orange"/>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
export default Increment;
